import http from "@/components/services/http-common";

export const getContents = () => {
  return http("contents/personal").then(d => d.data)
}
